module.exports = __webpack_public_path__ + "img/Feature.d2eeacd6.jpg";